/*
*
* File JS per il template Archive Magazine
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------/
import archiveFilters from 'components/archive-filters/archive-filters';

import product from 'components/product/product';

import pagination from 'components/pagination/pagination';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-product.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

archiveFilters();

product();

//--------------------------------------------------------------------//